module.exports = __webpack_public_path__ + "img/trend-up.c47cb7d4.svg";